import axiosInstance from "../../axios/axiosInstance";
import {
  GET_BLOOD_TEST_ERROR,
  GET_BLOOD_TEST_SUCCESS,
} from "../actionTypes/firstStepActionTypes";

export const setBloodTestLoading = (loading) => ({
  type: "SET_BLOOD_TEST_LOADING",
  payload: loading,
});

export const getBloodTests = () => async (dispatch, getState) => {
  try {
    const state = getState();

    if (state.firstStep?.bloodTestLoading) {
      return;
    }

    dispatch(setBloodTestLoading(true));

    const profileData = state?.getBloodTestFirst?.getProfileData;
    const userData = profileData?.profiles?.Items?.map((item) => ({
      name: item?.FullName?.S,
      ProfileID: item?.ProfileID?.S,
      isDefault: item?.isDefault?.S,
    }));

    if (!userData || userData.length === 0) {
      dispatch({
        type: GET_BLOOD_TEST_SUCCESS,
        payload: [],
      });
      return;
    }

    const finalBloodTest = [];

    const validProfiles = userData.filter(
      (item) => !item?.ProfileID?.includes("DELETED")
    );

    const bloodTestPromises = validProfiles.map(async (item) => {
      try {
        const response = await axiosInstance(`v1/getBloodTests`, "post", {
          profileId: item?.ProfileID,
        });

        const bloodTests = response?.data?.data?.bloodTests?.Items || [];

        const validBloodTests = bloodTests.filter(
          (value) =>
            value?.BloodTestStatus?.S === "Scan Complete" &&
            value?.Results?.length > 0
        );

        const processedBloodTests = validBloodTests.map((value) => ({
          ...value,
          resultLength: value?.Results?.length,
        }));

        return {
          reports: processedBloodTests.length,
          name: item?.name,
          profileId: item?.ProfileID,
          isDefault: item?.isDefault,
        };
      } catch (error) {
        console.error(`Error fetching blood tests for ${item.name}:`, error);
        return {
          reports: 0,
          name: item?.name,
          profileId: item?.ProfileID,
          isDefault: item?.isDefault,
        };
      }
    });

    const results = await Promise.all(bloodTestPromises);

    dispatch({
      type: GET_BLOOD_TEST_SUCCESS,
      payload: results,
    });
  } catch (error) {
    console.error("Error in getBloodTests action:", error);
    dispatch({
      type: GET_BLOOD_TEST_ERROR,
      payload: error.message,
    });
  }
};

export const selectBloodTestData = (state) => ({
  bloodTests: state.firstStep.bloodTests,
  loading: state.firstStep.bloodTestLoading,
  error: state.firstStep.error,
});
